import {formatLocalDateTime} from './formatLocalDateTime.ts'
import dayjs from 'dayjs'
import type {UserSettings} from '@package/shared'
import type {Formatter} from 'react-timeago'

export const getTimeAgoFormatter: (userSettings: UserSettings) => Formatter = (userSettings: UserSettings) => {
  return (value, unit, suffix, timestamp) => {
    if (unit === 'second' || suffix === 'from now') return 'just now'

    if (unit === 'minute' && value === 1) return `${value} minute ago`
    if (unit === 'minute' && value > 1) return `${value} minutes ago`

    if (unit === 'hour' && value === 1) return `${value} hour ago`
    if (unit === 'hour' && value > 1) return `${value} hours ago`

    return formatLocalDateTime(dayjs(timestamp), userSettings)
  }
}
